import { useEffect, useState } from 'react';

import { isStandalone } from '@/lib/pwa/is-standalone';

export function useIsStandalone(): boolean {
  const [standalone, setStandalone] = useState<boolean>(() => isStandalone());

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;

    const mediaQuery = window.matchMedia('(display-mode: standalone)');

    const handleChange = (event: MediaQueryListEvent) => {
      setStandalone(event.matches || isStandalone());
    };

    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return standalone;
}
